import React from "react";

function GetStartedBanner() {
  return (
    <section
      className="w-full py-2 sm:py-3 text-center"
      style={{ backgroundColor: "#5786ff" }}
    >
      <div className="max-w-screen-xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2
          className="text-2xl sm:text-3xl md:text-4xl font-bold text-white leading-relaxed mb-6 max-w-3xl mx-auto"
          style={{
            fontFamily: "'Signika Negative', sans-serif",
          }}
        >
          Get Started at A Plus Flavor
        </h2>

        <div className="max-w-3xl mx-auto space-y-4">
          <p className="text-base sm:text-lg text-white leading-relaxed">
            Craving real Haitian food done right? Stop by A Plus
            Flavor or place your order online for quick and
            convenient service. We offer both carry-out and
            delivery, making it easy to enjoy your favorite
            dishes wherever you are.
          </p>

          <p className="text-base sm:text-lg text-white leading-relaxed">
            Every order is prepared fresh and packed to stay hot
            and flavorful, so whether you're dining in, taking it
            home, or having it delivered, the taste is just as
            rich and satisfying as if you were eating in our
            restaurant. Real food. Real flavor. Every time.
          </p>
        </div>
      </div>
    </section>
  );
}

export default GetStartedBanner;
